import _ from "lodash";
import { Box } from "@mui/material";
import { useRef } from "react";
import { useState, useEffect, useLayoutEffect, useMemo } from "react";
import ButtonV1 from "../toolkit/ButtonV1";
import LeftChevron from "../icons/LeftChevron";
import RightChevron from "../icons/RightChevron";
import "./Large.css";

export default function ({ children, className, getElementsArray }) {
  const containerRef = useRef(null);
  const [scrollerPos, setScrollerPos] = useState(0);
  const [showButtons, setShowButtons] = useState(false);
  const [disabledButtons, setDisabledButtons] = useState({
    left: true,
    right: true,
  });

  useLayoutEffect(() => {
    setShowButtons(getExcessWidth() > 10);
  });

  useLayoutEffect(() => {
    const excessWidth = getExcessWidth();
    setDisabledButtons({
      left: scrollerPos === 0,
      right: scrollerPos < -1 * excessWidth,
    });
  }, [showButtons, scrollerPos]);

  function getStepWidth() {
    const elements = getElementsArray();
    return _.min(elements.map((e) => e.offsetWidth));
  }

  function getRequiredWidth() {
    const elements = getElementsArray();
    return elements.reduce((total, cur) => total + cur.offsetWidth, 0);
  }

  function getExcessWidth() {
    return getRequiredWidth() - containerRef.current?.offsetWidth || 0;
  }

  function handleResize() {
    setScrollerPos(0);
    setShowButtons(getExcessWidth() > 10);
  }

  const debouncedResizeHandler = useMemo(
    () => _.debounce(handleResize, 500),
    []
  );

  useEffect(() => {
    window.addEventListener("resize", debouncedResizeHandler);
  }, []);

  function navButtonClicked(direction) {
    if (direction === "left") {
      setScrollerPos((prev) => {
        const newPos = prev + getStepWidth();
        return newPos < 0 ? newPos : 0;
      });
    } else if (direction === "right") {
      setScrollerPos((prev) => {
        const excessWidth = getExcessWidth();
        const newPos = prev - getStepWidth();
        return prev > -1 * excessWidth ? newPos : prev;
      });
    }
  }
  ;

  return (
    <>
      <Box className={`${className} stepper-container`} ref={containerRef}>

        <Box className="stepper-containers">
          <Box className="scroll-context" sx={{ left: `${scrollerPos}px` }}>
            {children}
          </Box>
        </Box>

        {/* {showButtons ? (<>
           <Box className="buttons"> 
           
              <ButtonV1
                className="left"
                size="small"
                leadingComponent={<LeftChevron />}
                role="tertiary"
                onClick={() => navButtonClicked("left")}
                disabled={disabledButtons.left}
              />
            
            
              <ButtonV1
                className="right"
                size="small"
                leadingComponent={<RightChevron />}
                role="tertiary"
                onClick={() => navButtonClicked("right")}
                disabled={disabledButtons.right}
              />
            
          </Box> 
        </>
        ) : (
          <></>
        )} */}
        
      </Box>
    </>
  );
}
